import { ProductKeyDb } from "../database/models/ProductKeyDb";

export class ProductKey {
    guid: string;
    voucherGuid: string | null;
    key: string;
    companyGuid: string;
    productGuid: string;
    activationDate: Date | null;
    expirationDate: Date | null;

    originCompanyGuid: string | null;
    originProductGuid: string | null;
    transferredDate: Date | null;

    createdDate: Date | null;
    lastModifiedDate: Date | null;
    deletedDate: Date | null;

    constructor(
        guid: string,
        voucherGuid: string | null,
        key: string,
        companyGuid: string,
        productGuid: string,
        activationDate: Date | null,
        expirationDate: Date | null,
        originCompanyGuid: string | null,
        originProductGuid: string | null,
        transferredDate: Date | null,
        createdDate: Date | null,
        lastModifiedDate: Date | null,
        deletedDate: Date | null,
    ) {
        this.guid = guid;
        this.voucherGuid = voucherGuid;
        this.key = key;
        this.companyGuid = companyGuid;
        this.productGuid = productGuid;
        this.activationDate = activationDate;
        this.expirationDate = expirationDate;

        this.originCompanyGuid = originCompanyGuid;
        this.originProductGuid = originProductGuid;
        this.transferredDate = transferredDate;

        this.createdDate = createdDate;
        this.lastModifiedDate = lastModifiedDate;
        this.deletedDate = deletedDate;
    }
}

export function ProductKeyToDbMapper(model: ProductKey) {
    const mapped: ProductKeyDb = {
        guid: model.guid,
        voucherGuid: model.voucherGuid,
        key: model.key,
        companyGuid: model.companyGuid,
        productGuid: model.productGuid,
        activationDate: model.activationDate,
        expirationDate: model.expirationDate,

        originCompanyGuid: model.originCompanyGuid,
        originProductGuid: model.originProductGuid,
        transferredDate: model.transferredDate,

        createdDate: model.createdDate,
        lastModifiedDate: model.lastModifiedDate,
        deletedDate: model.deletedDate,
    };
    return mapped;
}

export function ProductKeyFromDbMapper(db: ProductKeyDb) {
    const mapped: ProductKey = new ProductKey(db.guid,
        db.voucherGuid,
        db.key,
        db.companyGuid,
        db.productGuid,
        db.activationDate,
        db.expirationDate,
        db.originCompanyGuid ?? null,
        db.originProductGuid ?? null,
        db.transferredDate ?? null,
        db.createdDate,
        db.lastModifiedDate,
        db.deletedDate,
    )
    return mapped;
}
